import React from 'react';

import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';


//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon } from '../inspinia'
import Pagination from "react-js-pagination";
import CircularProgress from '@material-ui/core/CircularProgress';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';


class CamposCampanhaAdesao extends React.PureComponent
{
    constructor(props)
    {
        super(props);     
        
        this.state = {
            loading: false, filter: "", page: 0,
            form: this.formInitialState(),
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, content: undefined
            },
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },            
            endPoint: '/campanha/adesao/campo',
            
        }

        this.handleBuscarInput      = this.handleBuscarInput.bind(this); 
        this.handlePageChange       = this.handlePageChange.bind(this);
        this.handleAdicionarCampo   = this.handleAdicionarCampo.bind(this);
        this.handleChange           = this.handleChange.bind(this);
        this.handleLimparPesquisa   = this.handleLimparPesquisa.bind(this);
        this.handleMensagemSucesso  = this.handleMensagemSucesso.bind(this);
    }

    formInitialState () 
    {
        return {
            id: "",
            campo: "",
        }
    }


    componentDidMount()
    {
        this.LoadListaCampo();
    }

    handleMensagemSucesso(nomeCampo)
    {
        c.TOASTER_SUCCESS(`Campo ${nomeCampo} cadastrado com sucesso!`);  
    }

    handleMensagemEdicao(nomeCampo)
    {
        c.TOASTER_SUCCESS(`Campo ${nomeCampo} editado com sucesso!`);  
    }

    handleLimparPesquisa(edicao)
    {        

        let nomeCampo = this.state.form.campo;

        this.state.list = [];
        this.state.form.id = '';
        this.state.form.campo = '';
        this.LoadListaCampo(this.state.page);
        
        if(edicao) {
            this.handleMensagemEdicao(nomeCampo);

        } else {
            this.handleMensagemSucesso(nomeCampo);

        }
    }

    handleChange(e) {

        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });

    }

    onNomeCampoChange(campoEdicao) {

        const form = this.state.form;

        this.setState({ form: { ...form, campo: campoEdicao.nome, id: campoEdicao.id } });

    }

    onLoadingChange(loading) {

        this.setState({...this.state, loading})

    }

    handleAdicionarCampo() {
        const form = this.state.form;

        if(this.state.form.campo.length == 0){
            c.TOASTER_ERROR(`Favor preencher o nome do campo!`);  

        } else {
            
            if(form.id === ''){
                this.SaveCampo();

            } else {
                this.EditarCampo(form.id);
            }

        }
        
    }

    SaveCampo(e) {

        let self = this;
        let url = `${c.API_BASE_URL}${self.state.endPoint}`
        
        const options = {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                nome: this.state.form.campo
            })
        };

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, loading: false, page: 0 }, self.handleLimparPesquisa());      
        });
    }
    

    EditarCampo(idCampo) {

        let self = this;
        let url = `${c.API_BASE_URL}${self.state.endPoint}/${idCampo}`
        
        const options = {
            method: 'PUT' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                nome: this.state.form.campo
            })
        };    

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, loading: false, page: 0 }, self.handleLimparPesquisa(true));      
        });

    }

    handleBuscarInput(e)
    {
        this.setState({ ...this.state, filter: e.target.value });   
    }


    handlePageChange(pageNumber) 
    {

        this.state.page = pageNumber;
        this.LoadListaCampo(pageNumber);
    }

    render()
    {


        return (                     
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Listas de Campos</h3>
                            </Title>

                            <Content>
                                
                                <Row className="m-0 mb-3">
                                    <Column size="12" className="p-0 mx-auto container">

                                        <Row className="form-row">
                                            <div className="form-group col-md-5">   
                                                <input type="text" name="campo" value={this.state.form.campo} onChange={this.handleChange} className="form-control" placeholder="Novo campo"/>                                                 
                                            </div>
                                            <div className="form-group col-md-5">
                                                <Button onClick={this.handleAdicionarCampo} class="btn btn-primary">Incluir</Button>                                                   
                                            </div>  
                                            <div className="form-group col-md-2">
                                                {this.state.loading && (                    
                                                    <CircularProgress />                    
                                                )}
                                            </div>  
                                                                            
                                        </Row> 
                                        
                                    </Column>

                                    
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this.props.history} contexto={this}/>                                        
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                     
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>                
            </div>
        );
    }
 
    LoadListaCampo(pageNumber)
    {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;
        
        const url = `${c.API_BASE_URL}${self.state.endPoint}?page=${page}&size=${size}`;
        const options = self.state.optionsGet;
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, list: response});
        });
    }
}

class Table extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            loading: false,
            alerta: withReactContent(Swal),
        }

        this.editarClick   = this.editarClick.bind(this);
        this.excluirClick = this.excluirClick.bind(this);
        this.onClickExcluir = this.onClickExcluir.bind(this);
    }

    editarClick(id)
    {
        if (parseInt(id) === 0) return;        

        let campos = this.props.data.content;
        let nomeCampo = '';

        nomeCampo = campos.filter((campo) => campo.id === id);

        this.props.contexto.onNomeCampoChange(nomeCampo[0]);

    }


    excluirClick(id)
    {
        if (parseInt(id) === 0) return;

        this.onClickExcluir(id);     

    }

    onClickExcluir(id) {
        this.state.alerta.fire({
            title: 'Realmente deseja excluir este campo?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {
                return this.LoadExcluir(id);
            },
            allowOutsideClick: () => !this.state.alerta.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                this.state.alerta.fire({
                    title: 'Cancelado',
                    text: 'Campo não excluído',
                    icon: 'error',
                    confirmButtonColor: '#47A789'
                })
            }
        });
    }

    statusEnvio(status){
        if (status == "Em Uso"){
            return( <span style={{color:"#EF7800"}}>Em Uso</span>)
        }
        else if (status == "Ativa"){
            return( <span style={{color:"#009966"}}>Ativa</span>)
        }
        else if (status == "Utilizada"){
            return( <span style={{color:"#BBBBBB"}}>Rejeitado</span>)
        }
    }

    LoadExcluir(id)
    {

        let self = this;
        let url = `${ c.API_BASE_URL }${ this.props.contexto.state.endPoint }/${id}`
        
        const options =
        {
            method: 'DELETE'
            ,headers: { 'Content-Type': 'application/json' }
        };

        callApi(url, options, function(response)
        { 
            self.props.contexto.LoadListaCampo(0);

            self.props.contexto.onLoadingChange(false);

            c.TOASTER_SUCCESS("Campo excluído com sucesso!"); 

        });

    }



    render()
    {    
        const data = this.props.data; 
        let html = "";

        if (data.content === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.content.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length   > 0)
        {
            html = data.content.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{row.nome}</td>                             
                    <td className="text-center">
                        <a onClick={() => this.editarClick(row.id)}><Icon name="fa-pencil" className="mx-1 text-success"/></a>
                        <a onClick={() => this.excluirClick(row.id)}><Icon name="fa-times" className="mx-1 text-muted"/></a>
                    </td>
                </tr>                  
            );
        }

        return(
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}>       
                        <th>#</th>
                        <th>Nome do campo</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CamposCampanhaAdesao));
